import { useState } from "react";
import { Create, Datagrid, List, NumberField, TextField } from "react-admin";

import { Edit, NumberInput, SimpleForm, TextInput } from "react-admin";
import { LVEditToolbar } from "../core/toolbars";

const validateEditors = (values) => {
    let errors = {};

    // Validate percentileLow, percentileMid, and percentileHigh
    if (values.percentileLow !== undefined && (values.percentileLow < 0 || values.percentileLow > 100))
        errors.percentileLow = "Must be between 0 and 100";

    if (values.percentileMid !== undefined && (values.percentileMid < 0 || values.percentileMid > 100))
        errors.percentileMid = "Must be between 0 and 100";

    if (values.percentileHigh !== undefined && (values.percentileHigh < 0 || values.percentileHigh > 100))
        errors.percentileHigh = "Must be between 0 and 100";

    // Check percentile ordering
    if (values.percentileLow >= values.percentileMid) errors.percentileLow = "Must be less than Percentile Mid";

    if (values.percentileMid >= values.percentileHigh) errors.percentileMid = "Must be less than Percentile High";

    // Validate Color
    if (!/^#[0-9A-F]{6}$/i.test(values.color)) errors.color = "Must be a valid hex color (e.g. #FFFFFF)";

    // Validate transient assumption multiplier
    if (values.transientLoadingAssumptionMultiplier < 0 || values.transientLoadingAssumptionMultiplier > 100)
        errors.transientLoadingAssumptionMultiplier = "Must be between 0 and 100";

    // Validate Max Operating Temperature
    if (values.maximumOperatingTemperatureC < 0 || values.maximumOperatingTemperatureC > 300)
        errors.maximumOperatingTemperatureC = "Must be between 0 and 300";

    // Validate Transient Duration Mins
    if (values.transientDurationMins < 1 || values.transientDurationMins > 10000)
        errors.transientDurationMins = "Must be between 1 and 10000";

    return errors;
};

export const EmergencyRatingConfigList = () => (
    <List>
        <Datagrid bulkActionButtons={null} rowClick="edit">
            <TextField source="emergencyRatingId" />
            <TextField source="title" />
            <TextField source="percentileLow" />
            <NumberField source="percentileMid" />
            <TextField source="percentileHigh" />
            <NumberField source="maximumOperatingTemperatureC" />
            <NumberField source="transientDurationMins" />
            <NumberField source="transientLoadingAssumptionMultiplier" />
            <TextField source="title" />
            <TextField source="color" />
        </Datagrid>
    </List>
);

export const EmergencyRatingConfigEdit = () => (
    <Edit>
        <SimpleForm toolbar={<LVEditToolbar />} validate={validateEditors}>
            <TextInput source="emergencyRatingId" />
            <TextInput source="title" />
            <TextInput source="percentileLow" />
            <NumberInput source="percentileMid" />
            <TextInput source="percentileHigh" />
            <NumberInput source="maximumOperatingTemperatureC" />
            <NumberInput source="transientDurationMins" />
            <NumberInput source="transientLoadingAssumptionMultiplier" />
            <TextInput source="color" />
        </SimpleForm>
    </Edit>
);

const colorStyles = {
    position: "relative",
    width: "40px",
    height: "40px",
    marginLeft: "10px",
    top: "-9px",
};

export const EmergencyRatingConfigCreate = () => {
    const [bgColor, setBgColor] = useState("#FFFFFF");

    const setColor = (e) => {
        let color = e.target.value;
        if (color && color.length >= 6) {
            if (color[0] !== "#") {
                color = "#" + color;
            }
            setBgColor(color);
        }
    };

    return (
        <Create>
            <SimpleForm toolbar={<LVEditToolbar />} validate={validateEditors}>
                <TextInput label="Emergency Rating ID" source="emergencyRatingId" />
                <TextInput source="title" />
                <TextInput source="percentileLow" />
                <NumberInput source="percentileMid" />
                <TextInput source="percentileHigh" />
                <NumberInput source="maximumOperatingTemperatureC" />
                <NumberInput source="transientDurationMins" />
                <NumberInput source="transientLoadingAssumptionMultiplier" />

                <div style={{ display: "flex", alignItems: "center" }}>
                    <TextInput
                        onChange={(e) => setColor(e)}
                        value={bgColor}
                        label="Hex Color (e.g. #FFFFFF) "
                        source="color"
                    />
                    <div
                        style={{
                            backgroundColor: bgColor,
                            ...colorStyles,
                        }}
                    ></div>
                </div>
            </SimpleForm>
        </Create>
    );
};
